import React, {Component} from 'react';
import * as d3 from "d3";

class graph extends Component {
    makeGraph(data) {
        // set the dimensions and margins of the graph
        const labelName = {
            volume:    '-- Email limit',
            postponed: '-- Emails in queue',
            processed: '-- Emails sent',
        };
        const wrapper = document.querySelector('.graphWrapper');
        const margin = { top: 30, right: 150, bottom: 30, left: 50 };
        const width = (wrapper ? wrapper.clientWidth : 1100) - margin.left - margin.right;
        const height = 500 - margin.top - margin.bottom;

        // append the svg object to the body of the page
        const svg = d3.select(".graphWrapper")
            .append("svg")
            .attr("width", width + margin.left + margin.right)
            .attr("height", height + margin.top + margin.bottom)
            .append("g")
            .attr("transform",
                "translate(" + margin.left + "," + margin.top + ")");

        // List of groups (here I have one group per column)
        const allGroup = ["processed", "volume", "postponed"];

        // Reformat the data: we need an array of arrays of {x, y} tuples
        const dataReady = allGroup.map(function (grpName) { // .map allows to do something for each element of the list
            return {
                name: grpName,
                values: data.map(function (d) {
                    const yearMonthDay = d.day.split('-');
                    return {
                        time:         new Date(+yearMonthDay[0], (+yearMonthDay[1]) - 1, +yearMonthDay[2], +d.hour),
                        value:        d[grpName],
                        combinedData: d,
                    };
                }),
            };
        });
        // I strongly advise to have a look to dataReady with
        //console.log(dataReady);

        // A color scale: one color for each group
        const myColor = d3.scaleOrdinal()
            .domain(allGroup)
            .range(d3.schemeSet2);

        // Max value in all category
        const maxValue = (function () {
            let res = 0;

            dataReady.forEach(item => {
                let currentMax = d3.max(item.values, function (d) {
                    return d.value;
                });

                if (res < currentMax) {
                    res = currentMax;
                }
            });

            return res;
        }());

        // Add X axis --> it is a date format
        const x = d3.scaleTime()
            .domain([
                new Date(dataReady[0].values[0].time.getTime() - 3600000),
                dataReady[0].values[dataReady[0].values.length - 1].time,
            ])
            .range([0, width]);
        x.ticks(data.length);
        svg.append("g")
            .attr("transform", "translate(0," + height + ")")
            .call(d3.axisBottom(x));

        // Add Y axis
        const y = d3.scaleLinear()
            .domain([0, maxValue + maxValue * 0.1])
            .range([height, 0]);
        svg.append("g")
            .call(d3.axisLeft(y));

        // Add the lines
        const line = d3.line()
            .x(function (d) {
                return x(d.time);
            })
            .y(function (d) {
                return y(+d.value);
            });
        svg.selectAll("myLines")
            .data(dataReady)
            .enter()
            .append("path")
            .attr("d", function (d) {
                return line(d.values);
            })
            .attr("stroke", function (d) {
                return myColor(d.name);
            })
            .style("stroke-width", 3)
            .style("fill", "none");

        // create a tooltip
        const tooltip = d3.select(".graphWrapper")
            .append("div")
            .style("opacity", 0)
            .attr("class", "tooltip")
            .style("background-color", "white")
            .style("border", "solid")
            .style("border-width", "2px")
            .style("border-radius", "5px")
            .style("padding", "5px");

        // Three function that change the tooltip when user hover / move / leave a cell
        const mouseover = function () {
            tooltip
                .style("opacity", 1);
        };
        const mousemove = function (d) {

            let formatedDate = (function () {
                let yearMonthDay = d.combinedData.day.split('-');

                return yearMonthDay.reverse().join('/');
            }());
            let html = '' +
                'Date: ' + formatedDate + '<br/>' +
                'Period: ' + d.combinedData.hour + ':00 - ' + d.combinedData.hour + ':59<br/>' +
                '<span style="color:#66c2a5">Emails sent: ' + d.combinedData.processed + '</span><br/>' +
                '<span style="color:#fc8d62">Email limit: ' + d.combinedData.volume + '</span><br/>' +
                '<span style="color:#8da0cb">Emails in queue: ' + d.combinedData.postponed + '</span>';

            tooltip
                .html(html)
                .style("left", (d3.mouse(this)[0] + 70) + "px")
                .style("top", (d3.mouse(this)[1]) + "px");
        };
        const mouseleave = function (d) {
            tooltip
                .style("opacity", 0);
        };
        const tooltipWidth = x(dataReady[0].values[0].time);

        // Add the points
        svg
        // First we need to enter in a group
            .selectAll("myDots")
            .data(dataReady)
            .enter()
            .append('g')
            .style("fill", function (d) {
                return myColor(d.name);
            })
            // Second we need to enter in the 'values' part of this group
            .selectAll("myPoints")
            .data(function (d) {
                return d.values;
            })
            .enter()
            .append("circle")
            .attr("cx", function (d) {
                return x(d.time);
            })
            .attr("cy", function (d) {
                return y(d.value);
            })
            .attr("r", 2)
            .attr("stroke", "white");
        //add tooltip line
        svg
            .selectAll("tooltipArea")
            .data(dataReady.slice(0, 1))
            .enter()
            .append('g')
            .classed("tooltipWrapper", true)
            .selectAll("tooltip")
            .data(function (d) {
                return d.values;
            })
            .enter()
            .append("rect")
            .on("mouseover", mouseover)
            .on("mousemove", mousemove)
            .on("mouseleave", mouseleave)
            .attr("x", function (d) {
                return x(d.time) - tooltipWidth;
            })
            .attr("y", function () {
                return y(maxValue + maxValue * 0.1);
            })
            .attr("width", function () {
                return tooltipWidth;
            })
            .attr("height", function () {
                return y(0);
            });

        // Add a legend at the end of each line
        svg
            .selectAll("myLabels")
            .data(dataReady)
            .enter()
            .append('g')
            .append("text")
            .datum(function (d) {
                return { name: d.name, value: d.values[d.values.length - 1] };
            }) // keep only the last value of each time sery
            .attr("x", width + 15) // shift the text a bit more right
            .attr("y", function (d, i) {
                return 20 * i;
            }) // shift the text a bit more top
            .text(function (d) {
                return labelName[d.name];
            })
            .style("fill", function (d) {
                return myColor(d.name);
            })
            .style("font-size", 15);
    }

    applyGraph() {
        const wrapper = document.querySelector('.graphWrapper');

        if (wrapper) {
            wrapper.innerHTML = '';
        }

        this.makeGraph(this.props.props.state.data);
    }

    componentDidMount() {
        window.addEventListener("resize", () => {
            this.forceUpdate();
        });
        this.applyGraph();
    }

    componentDidUpdate() {
        this.applyGraph();
    }

    render() {
        return (
            <div className="graphWrapper"></div>
        );
    }
}

export default graph;